import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'

import Skeleton from 'react-loading-skeleton'
import constants from 'lib/constants'
import { getQueryValue } from 'lib/helpers/queryValues'
import { publishEvent } from 'lib/events/tracking'

import useFetchBuilder from 'lib/hooks/useFetchBuilder'
import Layout from 'components/Layout'
import BuilderComponent from 'components/core/BuilderComponent'

import Event from 'types/Event'

const EverworldBlogPost = () => {
  const router = useRouter()
  const { query } = router
  const permalink = getQueryValue(query.permalink)
  const url = `/everworld/${permalink}`
  const model = 'everworld-blog-post'
  const { builderPage } = useFetchBuilder({ model, url })

  const blogPostData = builderPage?.data?.state?.blogPost?.data
  const { metaTitle, metaDescription, blurb, title, coverImage } = blogPostData || {}

  const seoTitle = metaTitle || title
  const seoDescription = metaDescription || blurb

  useEffect(() => {
    publishEvent(Event.Page.PAGE_VIEW)
  }, [])

  return (
    <Layout showFooter={!!builderPage}>
      <Head>
        {seoTitle ? <title>{seoTitle}</title> : <title>Everworld</title>}
        {seoDescription && (
          <meta property="description" name="description" content={seoDescription} />
        )}
        {seoTitle && <meta property="og:title" content={seoTitle} />}
        {seoDescription && <meta property="og:description" content={seoDescription} />}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${constants.URL_BASE}${url}`} />
        <meta property="og:site_name" content="Everlane" />
        {coverImage && <meta property="og:image" name="og:image" content={coverImage} />}
        <link rel="canonical" href={url} />
      </Head>
      <div>
        {builderPage ? (
          <BuilderComponent model={model} />
        ) : (
          <Skeleton height="50vh" width="100vw" />
        )}
      </div>
    </Layout>
  )
}

export default EverworldBlogPost
